import React from "react";

const LABEL = {
  pending: "Pending",
  in_review: "In review",
  in_progress: "In progress",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

export default function OrderStatusPill({ status }) {
  const cls = `status-pill status-${status}`;
  return <span className={cls} data-testid={`status-${status}`}>{LABEL[status] || status}</span>;
}
